import type React from "react";

import type { QuestionDto } from "@/api/types";
import { Card } from "@/design-system/Card";
import { useTranslation } from "@/translations";

import { MultipleChoiceWidget, OpenAnswerWidget, RatingWidget } from "./SurveyQuestionResponseWidgets";

interface SurveyQuestionResponseCardProps {
  question: QuestionDto;
  isSurveyEnded: boolean;
  canViewResults: boolean;
}

export function SurveyQuestionResponseCard({
  question,
  canViewResults,
  isSurveyEnded,
}: SurveyQuestionResponseCardProps): React.ReactNode {
  const { t } = useTranslation();

  return (
    <Card key={question.id}>
      <span className="text-body-emphasis">{question.question}</span>
      {canViewResults &&
        question.responses &&
        (question.responses.length > 0 ? (
          <>
            {question.type === "open" && <OpenAnswerWidget question={question} />}
            {question.type === "multipleChoice" && <MultipleChoiceWidget question={question} />}
            {question.type === "rating" && <RatingWidget question={question} />}
          </>
        ) : (
          <p className="my-space-sm text-text-secondary">
            {isSurveyEnded
              ? t("page.survey-details.no-responses.finished")
              : t("page.survey-details.no-responses.running")}
          </p>
        ))}
    </Card>
  );
}
